import React, { Component, Fragment } from 'react';
import {
    LoadingComponent, PageListComponent, HeaderListComponent,
} from "../../../common/component/Index";
import DEFINE, { PATHS } from "../../../../../constants/Define";
import { isEqual, get } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import SaleReport from '../../../../../models/SaleReport';

import Wrapper from './../../../common/component/Wrapper';

import { omit } from 'lodash';
import ReportSummary from './ReportSummary';
import ReportList from './ReportList';

import './SaleReports.less';

let permisionActions = [];
const defaultState = {

};

export default class SaleReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            filters: {},
        };
    }

    componentDidMount() {
        this.getSaleReports()
    }

    render() {
        const { t, hideHeader, reportState, orderState } = this.props;
        const { isFetching, saleReport } = reportState;
        return (
            <PageListComponent className="page-sale-report">
                {!hideHeader &&
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'reports'}
                        titleHeader={t('item.report.saleReport')}

                    />
                }
                <Wrapper className="">
                    <ReportSummary report={saleReport} loading={isFetching} />
                    <ReportList report={saleReport}
                        loading={isFetching}
                        downloading={orderState.isFetchingDownload}
                        onChangeFilters={this.getSaleReports}
                        onExportExcel={this.onExportExcel}
                        />
                </Wrapper>
            </PageListComponent>
        );
    }

    getSaleReports = (filters) => {
        const { reportState: { saleReport } } = this.props;
        if (!filters) filters = omit(saleReport.saleReportItems, ['items']);
        filters = omit(filters, ['totalCount', 'totalPage'])
        this.setState({ filters });
        this.props.getSaleReport(filters);
    }

    onExportExcel = (filters) => {
        this.props.exportExcel(filters);
    }

}

SaleReports.defaultProps = {
    hideHeader: false,
}
